import Icon, { type IconProps } from './Icon';
import { iconTypes, sizes } from './spritesheet/constants';
import type { IconType, Size } from './spritesheet/icon-types.d.ts';

export { Icon, type IconProps, type IconType, iconTypes, type Size, sizes };
export default Icon;
